import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Sheet from "components/sheet/Sheet";
import TipAllocationEditor, { TTipAllocationRow } from "components/tip/TipAllocationEditor";

interface ITipAllocationSheetProps {
  open: boolean;
  tipType: "card" | "cash";
  tipTotal: number;
  initialAllocations?: TTipAllocationRow[];
  currency?: string;
  okLoading?: boolean;
  onCancel: () => void;
  onOk: (allocations: TTipAllocationRow[]) => void;
}

export default function TipAllocationSheet(props: ITipAllocationSheetProps) {
  const { t } = useTranslation();
  const [allocations, setAllocations] = useState<TTipAllocationRow[] | null>(null);

  useEffect(() => {
    if (!props.open) {
      setAllocations(null);
    }
  }, [props.open]);

  return (
    <Sheet
      title={props.tipType === "cash" ? t("Edit cash tip allocations") : t("Edit tip allocations")}
      open={props.open}
      size="medium"
      closable
      onCancel={props.onCancel}
      onOk={() => {
        if (allocations?.length) {
          props.onOk(allocations);
        }
      }}
      okText={t("Save")}
      okDisabled={!allocations?.length}
      okLoading={props.okLoading}
    >
      <TipAllocationEditor
        tipTotal={props.tipTotal}
        value={props.initialAllocations}
        onChange={setAllocations}
        currency={props.currency}
      />
    </Sheet>
  );
}
